<template>
  <div class="tutorial-setting">
    <v-card class="text-center py-2 px-sm-10">
      <v-card-text v-if="profile">
        <div
          class="text-h5 font-weight-medium text--primary"
          style="opacity: 0.8"
        >
          Profil
        </div>
        <v-simple-table class="text-subtitle">
          <template v-slot:default>
            <tbody>
              <template v-for="item in getTableData()">
                <tr :key="item.key">
                  <td class="text-left" style="opacity: 0.8">
                    {{ item.key }}
                    <v-dialog
                      v-if="item.action"
                      transition="dialog-bottom-transition"
                      max-width="400"
                    >
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn icon class="ml-1" v-bind="attrs" v-on="on">
                          <v-icon small>mdi-pencil</v-icon>
                        </v-btn>
                      </template>
                      <template v-slot:default="dialog">
                        <v-card>
                          <v-card-text class="pt-3 pb-0">
                            <div
                              class="text-h5 font-weight-medium text--primary"
                              style="opacity: 0.8"
                            >
                              {{ item.key }}
                            </div>
                          </v-card-text>
                          <v-divider></v-divider>
                          <v-card-text class="pt-0 pb-1">
                            <div>{{ item.action.text }}</div>
                            <div v-if="item.key == 'E-Mail'">
                              <v-text-field
                                v-model="profile.email"
                                class="mt-2"
                                outlined
                                hide-details
                                single-line
                              />
                            </div>
                          </v-card-text>
                          <v-divider></v-divider>
                          <v-card-actions class="justify-end pt-0 pb-3">
                            <v-btn text @click="dialog.value = false"
                              >Schließen</v-btn
                            >
                            <v-btn
                              color="primary"
                              text
                              @click="
                                {
                                  item.action.method;
                                  dialog.value = false;
                                }
                              "
                              >Speichern</v-btn
                            >
                          </v-card-actions>
                        </v-card>
                      </template>
                    </v-dialog>
                  </td>
                  <td class="text-right">
                    <div>{{ item.value || "nicht angegeben" }}</div>
                  </td>
                </tr>
              </template>
              <tr>
                <td class="text-left" style="opacity: 0.8">
                  Benachrichtigungen
                </td>
                <!-- enable button when linked to backend -->
                <td class="text-right">
                  <v-switch
                    v-model="profile.enableNotification"
                    @click="saveEmailNotificationChanges"
                  ></v-switch>
                </td>
              </tr>
            </tbody>
          </template>
        </v-simple-table>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import { defineComponent, ref, reactive } from "@vue/composition-api";
import { useUserServiceInject } from "@/context";
import { camelizeKeys } from "humps";

export default defineComponent({
  name: "SettingsView",
  methods: {
    getTableData() {
      return [
        { key: "Username", value: "@" + this.profile.username },
        { key: "Name", value: this.getName() },
        {
          key: "E-Mail",
          value: this.profile.email,
          action: {
            method: this.saveEmailNotificationChanges(),
            text: "Bitte geben Sie Ihre E-Mail-Adresse an:",
            type: "text",
          },
        },
        { key: "Rolle", value: this.getRole() },
      ];
    },
    getName() {
      if (this.profile.firstName && this.profile.lastName) {
        return this.profile.firstName + " " + this.profile.lastName;
      } else if (this.profile.firstName) {
        return this.profile.lastName;
      } else if (this.profile.lastName) {
        return this.profile.lastName;
      } else {
        return "";
      }
    },
    getRole() {
      if (this.isStaff) return "Admin";
      if (this.isTutor) return "Tutor";
      return "Student";
    },
  },
  setup(props, { root }) {
    const { username, isStaff, isTutor } = useUserServiceInject();
    const profile = ref();
    const editMode = ref(false);
    const matchings = ref([]);

    root.$axios
      .get("tutors/get_name_username/", { params: { tutor: username.value } })
      .then((res) => (profile.value = camelizeKeys(res.data)));

    const saveEmailNotificationChanges = () => {
      const payload = {
        email: profile.value.email,
        notification: profile.value.enableNotification,
      };

      root.$axios.post("user/update-setting", payload);
    };

    return {
      profile,
      editMode,
      matchings,
      saveEmailNotificationChanges,
      isStaff,
      isTutor,
    };
  },
});
</script>

<style lang="css" scoped>
td {
  padding: 1rem !important;
}

.v-input--selection-controls {
  margin-top: 0;
  padding-top: 0;
}

button {
  background-color: transparent !important;
}

.v-btn--icon.v-size--default {
  width: initial;
  height: initial;
}
</style>

<style>
.tutorial-setting .v-input__slot {
  text-align: right;
  display: inline;
  margin-bottom: 0;
}

.v-messages {
  min-height: 0;
  min-width: 0;
}
</style>
